/**
 * This file provides the corresponding API Calls
 *  to interact with a Backend (either local, or remote)
 */ // TO DO: I think we can remove this file and rely on SocialRemote directly since SocialLocal is not in use any more.
// The distinction between the two is a relict from when we couldn't connect to the staging backend for local development and needed a local mock api.
// Or even better: rewrite the api calls in SocialRemote directly into the corresponding epics using something like getAjaxSettings
// which is used for making api calls to the cBook backend.
import SocialAPI, { getAjaxConfig } from "./api/SocialRemote";
export default SocialAPI;
export var getConfig = getAjaxConfig;
